import angular from 'angular';
import uiRouter from 'angular-ui-router';
import vehicleEditComponent from './vehicleEdit.component';
import VehicleInformation from './vehicleInformation/vehicleInformation';
import VehiclePricing from './vehiclePricing/vehiclePricing';
import VehicleDetails from './vehicleDetails/vehicleDetails';
import VehicleImages from './vehicleImages/vehicleImages';
import ServiceHistory from './serviceHistory/serviceHistory';
import Tabs from 'angular-ui-bootstrap/src/tabs';

let vehicleEditModule = angular.module('vehicleEdit', [
  uiRouter,
  Tabs,
  VehicleInformation,
  VehiclePricing,
  VehicleDetails,
  VehicleImages,
  ServiceHistory
])

.config(($stateProvider, $urlRouterProvider) => {
  "ngInject";

  $stateProvider
    .state('vehicleAdd', {
      url: '/vehicle/add',
      component: 'vehicleEdit',
      params: {
        origin: { }
      }
    });

    $stateProvider
      .state('vehicleEdit', {
        url: '/vehicle/edit/:vehicleId',
        component: 'vehicleEdit',
        params: {
          origin: { }
        }        
      });
})

.component('vehicleEdit', vehicleEditComponent)

.name;

export default vehicleEditModule;



// WEBPACK FOOTER //
// ./client/app/components/vehicle/vehicleEdit/vehicleEdit.js